// constants
import { LabRegistrationActionTypes } from './constants';
import { LabRegistration as LabRegistrationData } from 'src/types/labRegistration';

export type LabRegistrationActionType = {
    type:
        | LabRegistrationActionTypes.API_RESPONSE_SUCCESS
        | LabRegistrationActionTypes.API_RESPONSE_ERROR
        | LabRegistrationActionTypes.GET_LAB_REGISTRATION
        | LabRegistrationActionTypes.ADD_LAB_REGISTRATION
        | LabRegistrationActionTypes.EDIT_LAB_REGISTRATION
        | LabRegistrationActionTypes.GET_LAB_REGISTRATIONS
        | LabRegistrationActionTypes.RESET
        | LabRegistrationActionTypes.RESET_SUCCESS
        | LabRegistrationActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const labRegistrationApiResponseSuccess = (
    actionType: string,
    data: LabRegistrationData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const labRegistrationApiResponseError = (
    actionType: string,
    data: LabRegistrationData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addLabRegistration = (params: any): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.ADD_LAB_REGISTRATION,
    payload: params,
});

export const editLabRegistration = (params: any): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.EDIT_LAB_REGISTRATION,
    payload: params,
});

export const getLabRegistration = (params: any): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.GET_LAB_REGISTRATION,
    payload: params,
});

export const getLabRegistrations = (params: any): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.GET_LAB_REGISTRATIONS,
    payload: params,
});

export const resetLabRegistration = (): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.RESET,
    payload: {},
});

export const resetLabRegistrationSuccess = (): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetLabRegistrationError = (): LabRegistrationActionType => ({
    type: LabRegistrationActionTypes.RESET_ERROR,
    payload: {},
});
